import React, {useEffect, useState} from 'react'
import {useStateContext} from '../context/StateContext';
import { matchTemplateFieldWithValue, userLogCheck, objectIsObject, deviceSubstitutionStatus, deviceLogsExpanded, errorAlert, unique, findKey, addLogToDoc, successAlert, sortById } from '../lib/utils';
import { nonConformityList } from '../lib/tableData';
import {useCreateReplace, useDeleteDocument} from '../hooks/mutations'
import VisDiv from './frontend_components/VisDiv';
import DeviceIcons from './DeviceIcons';
import { screenPosition, keyId } from '../lib/utils';
import deadlines from './Deadlines';
import UserIcon from './UserIcon';
import NonConformity from '../pages/non-conformity';
import { IoMdCheckmark } from 'react-icons/io';
import { clientUser, isGodMode } from '../lib/userPermissions';
import { IoIosInformationCircleOutline } from "react-icons/io";
import TextHighlight from './frontend_components/TextHighlight';
import { MdDateRange } from "react-icons/md";
import { FaExchangeAlt } from "react-icons/fa";
import { substitutionString } from '../lib/tableData';
import { v4 as uuidv4, v4 } from 'uuid';
import useNetworkStatus from '../hooks/useNetworkStatus';
import { useOfflineContext } from '../context/OfflineContext';
import { updateMaintenanceDate } from '../pages/device';
import TestButton from './frontend_components/TestButton';
import { useDebounce } from '../hooks/useDebounce';
import { MdOutlineAddTask } from "react-icons/md";

//import 'rc-swipeout/assets/index.less'; (web only)

/**
 * 
 * #devices
 * 
 * A device pin component used in the map view. It displays a colored box with the device position number and a device title.
 * It also contains a button to open the device page, a button to add a non conformity and a button to delete the device.
 * 
 * @param {object} device - a device object containing the device data
 * @param {string} title - a string to display as the device title
 * @param {string} leftBoxText - a string to display in the left box of the pin
 * 
 * @returns a JSX element containing the device pin
 */

const DevicePin = ({onClick=()=>{}, device, navigate, showCheck, subNonConformities, customerProducts, title, leftBoxText, deviceOrderedFields, updateRegister=()=>{}, offlineFn=()=>{}, replaceDevice=()=> {},}) => {
    
    const {
        currentTemplate,
        customerUsers,
        setCurrentDevice,
        devices,
        setDevices,
        setDeviceEdit,
        nonConformities,
        setDuplicateDevice, 
        setIndexPage,
        deviceNonConformities,
        //deviceOrderedFields,
        LDB,
        sUser,
        setScreenPosition,
        client,
        isWorksheet,
        site, 
        register,
        registers   
    } = useStateContext();

   
    //const networkStatus = useNetworkStatus()

    const P = "devicePin"
    const allTemplateFields = [
        ...!Array.isArray(currentTemplate?.fields) ? [] : currentTemplate?.fields,
        ...!Array.isArray(currentTemplate?.locations) ? [] : currentTemplate?.locations,
        ...!Array.isArray(currentTemplate?.dates) ? [] : currentTemplate?.dates,
    ]
    const {mutate: deleteDevice} = useDeleteDocument({
        onError:(err)=>{
            console.log("ERRORE Cancellazione", err)
            errorAlert("ERRORE, Il presidio non è stato eliminato")
        }
        })

    const locations = {
        floor:"100089e6-e85d-467f-92b2-958628470ea2",
        enFloor:"2f3709d5-b5bc-4971-b17a-af23188319f1",
        location:"2e587bd1-e26e-4938-9c26-d7c16199ffe6",
        positionNumber:"5710d994-8bc9-4981-a5af-94a535d27bbd",
        zone:"d770ea67-ef56-404d-a7be-37f18f6ea8be"
    }
    
    if(!device){
        //console.log("DEVICE NON ESISTE")
        return null
    }

    if(device._type!=='device'){
        //console.log("THE ITEM PASSED IS NOT OF TYPE DEVICE")
        return null
    }
    const nonConformitiesData = {
        device,
        client, 
        registerTemplate: currentTemplate, 
        nonConformities, 
        deviceNonConformities, 
        list: true, 
        LDB
    }

    const foundNonConformities = nonConformityList(nonConformitiesData)
    const allNonConformities = nonConformityList({...nonConformitiesData, list: false})
  
    const orderedNonConformities = !Array.isArray(deviceNonConformities) ? [] : deviceNonConformities
        ?.filter?.((x)=>
            {
                const now = Date.now()
                //return ( (x?.status == 'ORDINATO' || x?.status == 'COMPLETATO' && x?.completedOn > now - 1000 * 60 * 60 * 24) && x?.device?._ref == device?._id) 
                return x?.device?._ref == device?._id
            }
        )
    const orderedNonConformitiesData = {
        deviceNonConformities: orderedNonConformities,
        //deviceOrderedFields: deviceOrderedFields?.filter((x)=>!x?.hide),
        deviceOrderedFields,
        customerProducts,
        nonConformities,
        subNonConformities,
        sUser,
        client, 
        site, 
        register,
        customerUsers,
        currentTemplate,
        device,
        registers
    }

    const onClickPin = () => {
        //console.log("clicked pin", device);
        //console.log("nonConformities", allNonConformities)

        setScreenPosition(screenPosition())
        setDeviceEdit(false)
        setDuplicateDevice(false)
        setCurrentDevice(device)
        setIndexPage("DEVICE");
        scroll(0,0) 
        onClick()

    }
    const onClickComment = (e) => {
        e.stopPropagation();
        //console.log ("clicked comment")
        //console.log ("cdevice:", device)
    }
    const onClickDeleteDevice = (e) => {

        e.stopPropagation();
        //console.log ("clicked Add Non Conformity")
        //console.log ("cdevice:", device)
        
        
        let array = [...!Array.isArray(devices) ? [] : devices]

        let findDeviceIndex = !Array.isArray(array) ? -1 : array?.findIndex(x=>x._id == device._id)
        array.splice(findDeviceIndex,1)
        
        setDevices([...array])
        deleteDevice({documentId: device._id })
        
    }

    const onClickDuplicateDevice = (e) => {
        e.stopPropagation();
        console.log("duplicate")
        setCurrentDevice(device)
        setDuplicateDevice(true)
        setDeviceEdit(true)
        setIndexPage("DEVICE")
    }
  
    const leftBoxColour = () => {
        //#doneCheck
        const lastCheckDate = userLogCheck(device)?.date
        if(lastCheckDate) {
            const now = Date.now()
            const passedMills = now - lastCheckDate
            const checkResetDays = register?.checkResetDays ? register?.checkResetDays : 120
            const nMonths = 1000 * 60 * 60 * 24 * checkResetDays
            if(passedMills < nMonths) return "green"  
            return "blue"
        }
    }

    const expiry = deadlines(device, currentTemplate)
    const deviceStatus = deviceSubstitutionStatus({device, deviceStatus: device?.status, deadlines:expiry, client})

    const borderColor = () => {
        if(deviceStatus == "DA SOSTITUIRE") return {border: "1.5px solid red"}
        if(deviceStatus == "DA FORNIRE") return {border: "1.5px solid blue"}
        return {border: "1px solid #ccc"}
    }

    const statusTranslation = (status) => {
        if(status == "ATTIVO") return LDB(P,"active")
        if(status == "DA SOSTITUIRE") return LDB(P,"toSubstitute")
        if(status == "DA FORNIRE") return LDB(P,"toSupply")
        return status
    }
    const statusColor = (status) => {
        if(status == "ATTIVO") return "green"
        if(status == "DA SOSTITUIRE") return "red"
        if(status == "DA FORNIRE") return "amber"
        return status
    }
    const deviceLogs = device?.userLog ? device?.userLog : []
    const expandedDevice = {...device, userLog: deviceLogsExpanded(deviceLogs, customerUsers)}
    const doneBy = userLogCheck(expandedDevice)
    
    return (
      
        <div 
        className='device-pin-container'
        style={{...borderColor(), minHeight: "80px"}}
        onClick={onClickPin}
        >
            <div className='left-container' style={{backgroundColor: leftBoxColour()}}>
                <p className='left-text'>{leftBoxText ? leftBoxText : matchTemplateFieldWithValue(locations.positionNumber,device.locations)?.value}
                </p>
            </div>

            <div className='center-container' style={{paddingRight:"25px"}}>

                <div className='device-title-container'>
                    <h4>{title ? title : device.label}</h4>
                    <VisDiv style={{display:"flex", marginTop:"5px", marginBottom:"5px"}} rules={[true]}>
                        <TestButton buttonId='kspqowkspqo' message="pinData" consoleData={{device, foundNonConformities, nonConformitiesData}} />
                        {!Array.isArray(device?.fields) ? [] : device?.fields?.map?.((field, index, arr)=>{
                            const fieldValue = matchTemplateFieldWithValue(field?.templateField?._ref, arr)?.value

                            const hideValues = ["No", "X", "x", "Sì", "SÍ", "Sí",  ]
                            const templateField = allTemplateFields?.find?.(x=>x?._id == field?.templateField?._ref)    
                            //console.log("jmdlkasmdkladmlkas", {field, allTemplateFields, templateField})

                            if (templateField?.status == "ARCHIVIATO") return null
                            if(!fieldValue || hideValues.includes(fieldValue)) return null
                            //return `${fieldValue}${index !== arr.length-1 ? "," : ""} `
                            return(
                                <div key={index} style={{padding:"5px"}}>
                                    <TextHighlight highlight={"blue"} key ={index}>
                                        {fieldValue}
                                    </TextHighlight>   
                                </div>
 
                            )
                        })}
                    </VisDiv> 
                    <VisDiv style={{marginTop:"5px", marginBottom:"5px"}} rules={[matchTemplateFieldWithValue(locations.floor, device.locations)?.value]}>
                        <p className='device-info-text'>{LDB(P,"floor")}: <TextHighlight highlight={"blue"}>{matchTemplateFieldWithValue(locations.floor,device.locations)?.value}</TextHighlight></p>
                    </VisDiv>
                    <VisDiv style={{marginTop:"5px", marginBottom:"5px"}} rules={[matchTemplateFieldWithValue(locations.enFloor, device.locations)?.value]}>
                        <p className='device-info-text'>{LDB(P,"floor")}: <TextHighlight>{matchTemplateFieldWithValue(locations.enFloor,device.locations)?.value}</TextHighlight></p>
                    </VisDiv>
                    <VisDiv style={{marginTop:"5px", marginBottom:"5px"}} rules={[matchTemplateFieldWithValue(locations.location,device.locations)?.value]}>
                        <p className='device-info-text'>{LDB(P,"area")}: <TextHighlight highlight={"blue"}>{matchTemplateFieldWithValue(locations.location,device.locations)?.value}</TextHighlight></p>
                    </VisDiv>
                    <VisDiv rules={[matchTemplateFieldWithValue(locations.zone,device.locations)?.value]}                 
                    style={{ 
                        display: "flex", 
                        flexWrap: "wrap", // Allows wrapping when there's no space
                        alignItems: "flex-start", // Ensures items stay aligned to the left
                        textAlign: "left", // Ensures text aligns left
                        marginTop: "5px", 
                        marginBottom: "5px"
                    }}>
                         <div style={{marginTop: "4px", marginRight:"5px"}}><p className='device-info-text'>{LDB(P,"zone")}: </p></div>
                        <TextHighlight style={{ display: "block", textAlign: "left"  }} highlight={"blue"}>{matchTemplateFieldWithValue(locations.zone, device.locations)?.value}</TextHighlight>
                    </VisDiv>

                    <VisDiv rules={[!isWorksheet, foundNonConformities.length>0]} 
                       style={{ 
                        display: "flex", 
                        flexWrap: "wrap", // Allows wrapping when there's no space
                        alignItems: "flex-start", // Ensures items stay aligned to the left
                        textAlign: "left", // Ensures text aligns left
                        marginTop: "5px", 
                        marginBottom: "5px"
                    }}
                    >   
                        <div style={{marginTop: "8px", marginRight:"5px"}}>
                            <p className='device-info-text'>{LDB(P,"nonConformity")}:</p>           
                        </div>
                        {foundNonConformities?.map?.((nonConformity, index) => {
                            return(
                                <div key={index} style={{
                                        marginTop:"5px",
                                        marginRight:"5px", 
                                        textAlign: "left",
                                        display: "inline-block", // Allows wrapping to next line when needed
                                        whiteSpace: "normal" // Ensures text wraps properly inside
                                    }}>
                                    <TextHighlight style={{ display: "block", textAlign: "left"  }} highlight={"red"} key={index}>
                                        {nonConformity}
                                    </TextHighlight>   
                                </div>
                            )
                        })}
                    </VisDiv>
                    <VisDiv rules={[!isWorksheet, deviceStatus !== "ATTIVO"]}
                            style={{ 
                            display: "flex", 
                            flexWrap: "wrap", // Allows wrapping when there's no space
                            alignItems: "flex-start", // Ensures items stay aligned to the left
                            textAlign: "left", // Ensures text aligns left
                            marginTop: "5px", 
                            marginBottom: "5px"
                        }}>
                        <div style={{marginTop: "4px", marginRight:"5px"}}>
                            <p className='device-info-text'>{LDB(P,"status")}: </p>
                        </div>
                            <TextHighlight style={{ display: "block", textAlign: "left"  }} highlight={statusColor(deviceStatus)}>{statusTranslation(deviceStatus)}</TextHighlight>
                    
                    </VisDiv> 
                    <VisDiv rules={[!isWorksheet , clientUser(sUser), doneBy?.date]}>
                        <UserIcon
                            size={40}
                            bypassCurrentUser={true}
                            name
                            dateText={LDB("device", "lastCheck")}
                            date={doneBy?.date}
                            otherUser={doneBy.log?.postedBy}
                            
                        />
                    </VisDiv> 
                    <VisDiv style={{width:"100%"}} rules={[isWorksheet]}>
                        <OrderedNonConformities 
                            onClickPin={onClickPin} 
                            data={orderedNonConformitiesData}
                            offlineFn={offlineFn} 
                            replaceDevice={replaceDevice}
                            updateRegister={updateRegister}
                        />
                    </VisDiv>

                </div>

            </div>
            <VisDiv style={{backgroundColor:"white", marginRight:"5px", display:"flex", justifyContent:"flex-end", paddingLeft:"30px"}} className='icons-container'>
                <DeviceIcons 
                    registerTemplate={currentTemplate}
                    register={register}
                    device={device} 
                    nonConformities={nonConformities} 
                    duplicateFn={onClickDuplicateDevice}
                    hideDuplicateButton ={isWorksheet}
                />               
            </VisDiv> 
        </div>

    )
}

export default DevicePin

export const addMissingNonConformityToOrderedField = ({field, device, customerProducts, nonConformities}) => {
    const deviceNonConformities = ! Array.isArray(device?.nonConformities) ? [] : device?.nonConformities
    const findOrderFieldCustomerProduct = !Array.isArray(customerProducts) ? undefined : customerProducts?.find((z)=>z?._id == field?.customerProductId)
    if(device?.status == "DA FORNIRE" || findOrderFieldCustomerProduct?.supply) { 
        const findSupplyNonConformity = nonConformities?.find((nonConf)=>nonConf?.supply && nonConf?.registers?.some(x=>x?._ref == field?.registerTemplateId))
        if(!findSupplyNonConformity) return field
        const doc = {...field, nonConformity: findSupplyNonConformity?.label, deviceNonConformityId: field?.deviceNonConformityId ? field?.deviceNonConformityId : uuidv4(), nonConformityId: findSupplyNonConformity?._id}
        //console.log("qkjdnqkwndjk", {field, findOrderFieldCustomerProduct, findSupplyNonConformity, doc})

        return doc 
    }

    const orderedNonConformities = deviceNonConformities?.map((x)=>({deviceNonConformity: x, nonConformity: nonConformities?.find((y)=>y?._id == x?.nonConformity?._ref)}))
    const compatableNonConformities = !Array.isArray(orderedNonConformities) ? [] : orderedNonConformities?.filter(x=>!Array.isArray(findOrderFieldCustomerProduct?.nonConformities) ? false : findOrderFieldCustomerProduct?.nonConformities?.some(y=>y?._ref == x?.nonConformity?._id))
    if(!compatableNonConformities) return field
    if(!Array.isArray(compatableNonConformities)) return field
    if(compatableNonConformities?.length < 1) return field
    if(compatableNonConformities?.length == 1) {
        const compatableNonConformity = compatableNonConformities[0]
        const nonConformity = compatableNonConformity?.nonConformity
        const deviceNonConformity = compatableNonConformity?.deviceNonConformity
        const updateDoc = {...field, nonConformity: nonConformity?.label, deviceNonConformityId: deviceNonConformity?._id, nonConformityId: nonConformity?._id}
        //console.log("qòldqwòd,qwòld", {field, compatableNonConformities, updateDoc, compatableNonConformity})
            return updateDoc
        }
    if(compatableNonConformities?.length > 1) {
        const findSupplyNonConformity = !Array.isArray(compatableNonConformities) ? undefined : compatableNonConformities?.find((x)=>x?.nonConformity?.supply)
        const compatableNonConformity = findSupplyNonConformity? findSupplyNonConformity : compatableNonConformities[0]
        const nonConformity = compatableNonConformity?.nonConformity
        const deviceNonConformity = compatableNonConformity?.deviceNonConformity
        const updateDoc = {...field, nonConformity: nonConformity?.label, deviceNonConformityId: deviceNonConformity?._id, nonConformityId: nonConformity?._id}
       // console.log("oqdjoqiwjdoiqwj", {field, compatableNonConformities, updateDoc, compatableNonConformity})
            return updateDoc
        }
    return field
}

export const OrderedNonConformities = ({data={}, updateRegister=()=>{}, offlineFn=()=>{}, replaceDevice=()=> {}, onClickPin=()=>{}}) => {
    const {nonConformities,  subNonConformities, device, deviceNonConformities, sUser, client, site, currentTemplate, register, customerUsers, deviceOrderedFields, registers, customerProducts} = data
    const deviceDeadlines = deadlines(device, currentTemplate) ? deadlines(device, currentTemplate) : {}
    const orderedCustomerProducts = deviceOrderedFields?.map((x)=>customerProducts?.find((y)=>y?._id == x?.customerProductId))
    
    const deviceOrderedFieldsAndManual = deviceOrderedFields?.map((item)=> {
        if(!item?.nonConformityId) {
            //If order has no nonConformity assigned, automatically assigns a compatible one if it finds it
            return addMissingNonConformityToOrderedField({field: item, customerProducts, deviceNonConformities, device, nonConformities: [...!Array.isArray(nonConformities) ? [] : nonConformities, ...!Array.isArray(subNonConformities) ? [] : subNonConformities]})
        }
        return item
    })
    const orderedDeviceNonConformitiesIds = unique("deviceNonConformityId", deviceOrderedFieldsAndManual)?.map?.((x)=>x?.deviceNonConformityId)?.filter?.((x)=>x)

    const uniqueOrderedFieldsByNonConformity = unique("nonConformityId", deviceOrderedFieldsAndManual)?.map((field)=>{
        
        const findSupplyProduct = orderedCustomerProducts?.find((x)=>x?.supply)
        if(findSupplyProduct) { 
            const findOrderedField = deviceOrderedFields?.find((x)=>x?.customerProductId == findSupplyProduct?._id)
            if(findOrderedField) return findOrderedField
            return field
        }
        return field
    })
        
    return (
        <div onClick={(e) => e.stopPropagation()} style={{width:"100%", backgroundColor:"white", minHeight:"100px"}}>
            <TestButton buttonId='qlwkdqlwkdm' message='test Pin Non Conformities' consoleData={{deviceOrderedFieldsAndManual, deviceOrderedFields, orderedCustomerProducts, uniqueOrderedFieldsByNonConformity, orderedNonConformities: orderedDeviceNonConformitiesIds, deviceNonConformities, deviceDeadlines, device, register}}/>
           <VisDiv style={{textAlign: "left"}}>
{/*             <VisDiv rules = {[true, deviceNonConformities?.length > 0]}>
                <p>NON CONFORMITA':</p>
            </VisDiv> */}
            {!Array.isArray(deviceNonConformities) ? [] : 
                deviceNonConformities
                ?.filter?.((x)=>{
                    const findNonConformity = !Array.isArray(nonConformities) ? undefined : nonConformities?.find?.((y)=>y?._id == x?.nonConformity?._ref)
                    if(findNonConformity?.informative){
                        //console.log("ljcnbawkjebchjweab",findNonConformity)
                        return 
                    }
                    return orderedDeviceNonConformitiesIds?.some?.((y)=>y === x?._id)
                })
                ?.sort(sortById)
                ?.map?.((deviceNonConformity, index)=>{
                return <OrderedNonConformityPin 
                            offlineFn = {offlineFn}
                            updateRegister = {updateRegister}
                            replaceDevice = {replaceDevice}
                            key={index} 
                            deviceNonConformity={deviceNonConformity} 
                            orderFields={deviceOrderedFields
                                ?.filter?.((x)=>x?.deviceNonConformityId ==  deviceNonConformity?._id)
                            } 
                            data={data}
                        />
            })}
     
            {uniqueOrderedFieldsByNonConformity
                ?.filter?.((x)=>!deviceNonConformities
                    ?.some?.((y)=>{
                        return y?._id === x?.deviceNonConformityId})
                )
                ?.sort(sortById)
                ?.map?.((item, index)=>{
                    return(
                        <div key = {index}>
                            <OrderedFieldPin 
                                offlineFn = {offlineFn}
                                updateRegister = {updateRegister}
                                replaceDevice = {replaceDevice}
                                deviceDeadlines={deviceDeadlines} 
                                data={data}
                                orderField={item}
                                deviceOrderedFields={deviceOrderedFields}
                                onClickPin={onClickPin}
                            />
                        </div>
                    ) 
                })
            }
           

           </VisDiv>
        </div>
    )
}

    export const OrderedFieldPin = ({orderField, deviceDeadlines, deviceOrderedFields=[], data = {}, updateRegister=()=>{}, offlineFn = ()=>{}, replaceDevice=()=>{}, onClickPin=()=>{} }) => {
        const [viewProducts, setViewProducts] = useState(false)
        const {register, registers, nonConformities, subNonConformities, device, customerProducts} = data
        const {sUser} = useStateContext()
        const networkStatus = useNetworkStatus()
        const [note, setNote] = useState("")
        const noteDoc = {
                _id: note?._id ? note?._id : uuidv4(), 
                note: note?.note ? note?.note : "", 
                offerFieldIds: !Array.isArray(note?.offerFieldIds) ? deviceOrderedFields?.map?.((x)=>x?._id) : note?.offerFieldIds
            }
        useEffect(()=>{
            const findNote = !Array.isArray(register?.worksheetNotes) ? undefined : 
                register?.worksheetNotes?.find?.((x)=>deviceOrderedFields?.some?.((y)=>x?.offerFieldIds?.some?.((z)=>z == y?._id)))
                if(findNote) setNote(findNote)
        }, [register])
        const addUpdateNote = () => {
            const queryDoc = {
                id: register?._id, 
                //key: findKey(register, updatedNonConformityDoc()),
                doc: {...register, worksheetNotes: [...!Array.isArray(register?.worksheetNotes) ? [] : register?.worksheetNotes?.filter?.((x)=>x?._id !== note?._id), noteDoc]},
            }
            if(!networkStatus) {
                //console.log("OFFLINE")
                offlineFn(queryDoc, registers)
            }
            else{
                updateRegister(queryDoc)
            }
           console.log("NOTA AGGIORNATA", queryDoc)
        }
        const nonConformity = [
            ...!Array.isArray(nonConformities) ? [] : nonConformities, 
            ...!Array.isArray(subNonConformities) ? [] : subNonConformities
        ]?.find?.((nonConf)=>{ 

            if(!orderField?.nonConformityId){
                const findCustomerProduct = !Array.isArray(customerProducts) ? undefined : customerProducts?.find?.((x)=>x?._id == orderField?.customerProductId)
                if(device?.status == "DA FORNIRE" || findCustomerProduct?.supply) return nonConf?.supply && nonConf?.registers?.some(x=>x?._ref == orderField?.registerTemplateId) 
                return undefined
            }
            return nonConf?._id === orderField?.nonConformityId})

        const isItemADeadline  = deviceDeadlines?.checkData?.maintenanceTasksListIds?.some?.((x)=>x == orderField?.nonConformityId) 
        const isItemASubsitution = nonConformity?.substitution
        const isItemInDeadlineNotDone = deviceDeadlines?.data?.find?.((x)=>x?._id == orderField?.nonConformityId)
        const isDeviceArchived = device?.status == "ARCHIVIATO"
        const isDeviceSubbed = !!device?.subbedWithId
        const isToSupply = device?.status == "DA FORNIRE"

        const productsList = !Array.isArray(deviceOrderedFields) ? [] : deviceOrderedFields?.filter?.((x)=>x?.nonConformityId == orderField?.nonConformityId)?.map?.((y)=>y?.customerProduct)

        return (
        <div>    
            <div style={{display:"flex", alignItems:"center"}}>
                <TestButton message={"Testing substitutions"} buttonId='qwd7g98e' consoleData={{isItemADeadline, isItemInDeadlineNotDone, customerProducts, deviceOrderedFields, isToSupply, isDeviceArchived, isDeviceSubbed, device, deviceDeadlines, nonConformities, orderField, isItemASubsitution, nonConformity}}/>
                <VisDiv rules={[isItemADeadline || isItemASubsitution]}>
                    <VisDiv rules={[isItemInDeadlineNotDone, isItemADeadline]}>
                        <DeadlinePin 
                            data= {data} 
                            deviceDeadlines={[isItemInDeadlineNotDone]}
                            templateDeadlines = {deviceDeadlines}
                            offlineFn = {offlineFn}
                            updateRegister = {updateRegister}
                            replaceDevice = {replaceDevice}
                            onClickPin = {onClickPin}
                        />
                    </VisDiv>
                    <VisDiv rules={[!isDeviceSubbed, !isItemADeadline]}>
                        <DeadlinePin 
                            data= {data} 
                            substitutionItem={nonConformity}
                            deviceDeadlines={[isItemInDeadlineNotDone]}
                            templateDeadlines = {deviceDeadlines}
                            offlineFn = {offlineFn}
                            updateRegister = {updateRegister}
                            replaceDevice = {replaceDevice}
                            onClickPin = {onClickPin}
                        />
                    </VisDiv>
                    <VisDiv rules={[!isItemInDeadlineNotDone, (isItemADeadline || isItemASubsitution)]}>
                        <div style={{display:"flex", alignItems:"center", padding:"10px"}} >
                            <div style={{backgroundColor:"green", color:"white", display:"flex", alignItems:"center", justifyContent:"center", marginRight:"10px", width:"30px", height:"30px"}}>
                                <IoMdCheckmark size={15}/>
                            </div>
                            <p>{orderField?.customerProduct}</p>
                        </div>
                    </VisDiv>
                </VisDiv>
                <VisDiv rules={[isToSupply]}>
                        <div style={{display:"flex", alignItems:"center", padding:"10px"}} >
                            <div onClick={onClickPin} style={{backgroundColor:"red", color:"white", display:"flex", alignItems:"center", justifyContent:"center", marginRight:"10px", width:"30px", height:"30px"}}>
                                <MdOutlineAddTask size={22}/>
                            </div>
                            <p>{orderField?.customerProduct}</p>
                        </div>
                    
                </VisDiv>
                <VisDiv rules={[!isToSupply, nonConformity?.supply]}>
                    <div style={{display:"flex", alignItems:"center", padding:"10px"}} >
                        <div style={{backgroundColor:"green", color:"white", display:"flex", alignItems:"center", justifyContent:"center", marginRight:"10px", width:"30px", height:"30px"}}>
                            <IoMdCheckmark size={15}/>
                        </div>
                        <p>{orderField?.customerProduct}</p>
                    </div>
                </VisDiv>
                <VisDiv rules = {[!isItemADeadline, !isItemASubsitution, !isToSupply, !nonConformity?.supply]}>
                    <p>{orderField?.customerProduct}</p>
                </VisDiv>
                <div style={{cursor:"pointer", marginLeft:"6px"}} onClick={()=>setViewProducts(!viewProducts)}>
                    <IoIosInformationCircleOutline size={25} />
                </div>
            </div>
            <VisDiv rules={[viewProducts]} style={{textAlign: "left", marginLeft:"20px", color: "grey"}}>
                <VisDiv rules={[productsList?.length > 0]}>
                    <p>Prodotti Inclusi:</p>
                    <p>{productsList?.toString()}</p>
                </VisDiv>

                <p>Note:</p>
                <textarea 
                    type={"text"}
                    //onClick={(e)=>(e?.target?.value)} 
                    style={{fontSize:"12px", color:"#324d67", width: "100%", backgroundColor: `rgba(0, 0, 0, 0)`, padding: "5px", outline:"none", border: "1px solid #ccc", borderRadius: "5px"}} 
                    onChange={(e)=> setNote({...note, note: e.target.value})} 
                    onBlur={()=>addUpdateNote()}
                    value={note?.note} 
                    />
            </VisDiv>
        </div>
        )
    }
 
/*

                <VisDiv rules={[viewProducts]} style={{textAlign: "left", marginLeft:"20px", color: "grey"}}>
                    <VisDiv rules={[productsList?.length > 0]}>
                        <p>Prodotti Inclusi:</p>
                        <p>{productsList?.toString()}</p>
                    </VisDiv>

                    <p>Note:</p>
                    <textarea 
                        type={"text"}
                        //onClick={(e)=>(e?.target?.value)} 
                        style={{fontSize:"12px", color:"#324d67", width: "100%", backgroundColor: `rgba(0, 0, 0, 0)`, padding: "5px", outline:"none", border: "1px solid #ccc", borderRadius: "5px"}} 
                        onChange={(e)=> setNote(e.target.value)} 
                        value={note} 
                        />
                </VisDiv>
*/

export const OrderedNonConformityPin = ({replaceDevice=()=>{}, updateRegister=()=>{}, offlineFn=()=>{}, data={}, deviceNonConformity, orderFields}) => 
    {
        const {nonConformities, device, currentTemplate, deviceNonConformities, sUser, client, site, register, registers, customerUsers, deviceOrderedFields} = data
        const networkStatus = useNetworkStatus()

        // Add throttling to prevent duplicate replaceDevice calls
        const [throttledReplaceDevice] = useDebounce(replaceDevice, 1000); // 1 second throttle

        const [viewProducts, setViewProducts] = useState(false)
        const [note, setNote] = useState("")
        const noteDoc = {
                _id: note?._id ? note?._id : uuidv4(), 
                note: note?.note ? note?.note : "", 
                offerFieldIds: !Array.isArray(note?.offerFieldIds) ? deviceOrderedFields?.map?.((x)=>x?._id) : note?.offerFieldIds
            }
        useEffect(()=>{
            const findNote = !Array.isArray(register?.worksheetNotes) ? undefined : 
                register?.worksheetNotes?.find?.((x)=>deviceOrderedFields?.some?.((y)=>x?.offerFieldIds?.some?.((z)=>z == y?._id)))
                if(findNote) setNote(findNote)
        }, [register])
        const addUpdateNote = () => {
            const queryDoc = {
                id: register?._id, 
                //key: findKey(register, updatedNonConformityDoc()),
                doc: {...register, worksheetNotes: [...!Array.isArray(register?.worksheetNotes) ? [] : register?.worksheetNotes?.filter?.((x)=>x?._id !== note?._id), noteDoc]},
            }
            if(!networkStatus) {
                console.log("OFFLINE UPDATE NOTE")
                offlineFn(queryDoc, registers)
            }
            else{
                updateRegister(queryDoc)
            }
           console.log("NOTA AGGIORNATA", queryDoc)
        }
        const nonConformityInDevice = !Array.isArray(device?.nonConformities) ? undefined : device?.nonConformities?.find?.((x)=>x?._id === deviceNonConformity?._id)
        const productsList = orderFields?.map?.((x)=>x?.customerProduct)
        //console.log("nklnalkncaelkjncjek", productsList)
        const updateNonConformity = (data, device, updatedField) => {
            //console.log("ndscksancksancxsadkjnc", data, updatedField)
            const updateDeviceField = (nonConformity) => {
        
                const allTemplateNonConformities = (x) =>{ 
                    const nonConformities = !x?.nonConformities ? [] : x?.nonConformities
                    const array = [...nonConformities, x?.maxNonConformity, x?.minNonConformity, x?.zeroNonConformity ].filter?.(x=>x)
                    //console.log("array", array, x)
                    return array
                }
                const fieldTemplate = currentTemplate?.fields?.find?.(x=>allTemplateNonConformities(x)?.find?.(y=>y?._id == nonConformity?.nonConformity?._ref))
                const deviceField = device?.fields?.find?.(x=>x?.templateField?._ref==fieldTemplate?._id)
            
                const maintenanceFieldTemplate = currentTemplate?.dates?.find?.(x=>allTemplateNonConformities(x)?.find?.(y=>y?._id == nonConformity?.nonConformity?._ref))
                const maintenanceDeviceField = device?.dates?.find?.(x=>x?.templateField?._ref==maintenanceFieldTemplate?._id)
                
                const currentYear = new Date().getFullYear()
                const findListAnni = maintenanceFieldTemplate?.lists?.find?.(x=>x?.listName=="ANNI")
                const findCurrentYear = findListAnni?.fieldList?.find?.(x=>x?.label==currentYear)
                const datesValue = {...maintenanceDeviceField, values:[findCurrentYear]}
            
                return ({deviceField, fieldTemplate, maintenanceFieldTemplate, maintenanceDeviceField, datesValue})
            }
            
            const deviceFieldValue = [updateDeviceField(data)?.deviceField ? updateDeviceField(data)?.deviceField : updateDeviceField(data)?.maintenanceDeviceField]
            
            const nonConformities = device?.nonConformities ? device?.nonConformities : []
            const findNonConformity = !Array.isArray(nonConformities) ? undefined : nonConformities?.find?.(x=>x?._id == data?._id)
            const filteredNonConformities = nonConformities?.filter?.(z=>z?._id !== findNonConformity?._id )
    
    
            const updatedNonConformityDoc = () => {
        
                if(data?.status == "COMPLETATO" || data?.status == "ARCHIVIATO") {
                    if(updateDeviceField(data)?.fieldTemplate?.fieldType=="boolean"){ 
                   
                        const newfields = device.fields.filter?.(x=>x?.templateField?._ref !== deviceFieldValue[0]?.templateField?._ref)
                        const newDevice = {...device, fields:newfields, nonConformities:[...filteredNonConformities, data]}
                        return newDevice      
                    }
                    else if(updateDeviceField(data)?.fieldTemplate?.fieldType=="minMax"){
                   
                        const newfields = device.fields.filter?.(x=>x?.templateField?._ref !== deviceFieldValue[0]?.templateField?._ref)
                        const newDevice = {...device, fields:[...newfields, updatedField?.[0]],nonConformities:[...filteredNonConformities, data]}
                        return newDevice 
                    }
                    else if(updateDeviceField(data)?.maintenanceFieldTemplate){
                       
                        const newfields = device.fields.filter?.(x=>x?.templateField?._ref !== deviceFieldValue[0]?.templateField?._ref)
                        const newDevice = {...device, dates:[...newfields, updateDeviceField(data)?.datesValue],nonConformities:[...filteredNonConformities, data]}
                        return newDevice 
                    }
                    else {
                        
                        return({...device, nonConformities:[...filteredNonConformities, data]})}
                }
               
                return({...device, nonConformities:[...filteredNonConformities, data]})
            }  
            const queryDoc = {
                id: register?._id, 
                key: findKey(register, updatedNonConformityDoc()),
                doc: addLogToDoc(sUser,updatedNonConformityDoc(),"NonConformityUpdated"),
            }
                if(!networkStatus) {
                console.log("OFFLINE UPDATE NON CONF")
                offlineFn(queryDoc, registers)
            }
            else{
             throttledReplaceDevice(queryDoc)}
        }
        return (
            <div style={{cursor:"default"}}>
                <div style={{display:"flex", alignItems:"center"}}>
                    <NonConformity 
                        data={{client, site, nonConformities, customerUsers}} 
                        pin={true} 
                        device={device} 
                        deviceNonConformity={nonConformityInDevice} 
                        register={register} 
                        saveFn={updateNonConformity}
                    />
                    <div style={{cursor:"pointer"}} onClick={()=>setViewProducts(!viewProducts)}>
                        <IoIosInformationCircleOutline size={25} />
                    </div>
                   
                </div>
                <VisDiv rules={[viewProducts]} style={{textAlign: "left", marginLeft:"20px", color: "grey"}}>
                    <VisDiv rules={[productsList?.length > 0]}>
                        <p>Prodotti Inclusi:</p>
                        <p>{productsList?.toString()}</p>
                    </VisDiv>

                    <p>Note:</p>
                    <textarea 
                        type={"text"}
                        //onClick={(e)=>(e?.target?.value)} 
                        style={{fontSize:"12px", color:"#324d67", width: "100%", backgroundColor: `rgba(0, 0, 0, 0)`, padding: "5px", outline:"none", border: "1px solid #ccc", borderRadius: "5px"}} 
                        onChange={(e)=> setNote({...note, note: e.target.value})} 
                        onBlur={()=>addUpdateNote()}
                        value={note?.note} 
                        />
                </VisDiv>
            </div>
        )
       }

    export const DeadlinePin = ({data={}, templateDeadlines, deviceDeadlines, updateRegister=()=>{}, offlineFn=()=>{}, replaceDevice=()=> {}, substitutionItem=undefined, onClickPin=()=>{}}) => {
        const {nonConformities, device, deviceNonConformities, sUser, client, site, register, customerUsers, deviceOrderedFields, registers, currentTemplate} = data
        const networkStatus = useNetworkStatus()
        const dateFields = device?.dates

        // Add throttling to prevent duplicate replaceDevice calls
        const [throttledReplaceDevice] = useDebounce(replaceDevice, 1000); // 1 second throttle
       
        const currentDateinField = (templateField) => {
        
        //const yearsList = templateField?.lists?.find?.(z=>z?.listName == "ANNI")
        const currentYear = new Date().getFullYear()
        const currentMonth = new Date().getMonth()
        //const thisYearObject = yearsList?.fieldList?.find?.(y => y?.label == currentYear)
        const dateField = {
            _key: keyId(), 
            values:[{
                dateObject:{
                    year: currentYear,
                    month: currentMonth + 1 
                },
                value: currentYear?.toString(),
                 _key: keyId() }], 
            templateField: {_type: "reference", _ref:templateField?._id, _key: keyId()}
        }
        return dateField
    }
        return(
        <VisDiv rules={[deviceDeadlines.length>0]} className='new-device-container-top' style={{marginTop:"15px", marginBottom:"15px"}}>
        {!Array.isArray(deviceDeadlines) ? [] : deviceDeadlines?.map?.((item, index)=>{
            const changeDate = () => {
                updateMaintenanceDate({nonConformityTemplate: item, currentTemplate: currentTemplate, dateFields: dateFields, register, networkStatus, sUser, device, registers, replaceDevice: throttledReplaceDevice, offlineFn: offlineFn,})
            }

            const subRevision = () => {
                const  {deadlineType, data } = templateDeadlines
                 const isScadenzaCollaudoRevisione = deadlineType == "Scadenza-Collaudo-Revisione"
                 const isSubMaintenance = data?.some?.((x)=>x?.deadlineSubstitutionIfClientRevisionFalse)
                 const isClientRevision = client?.revision
         
                 if(isScadenzaCollaudoRevisione && isSubMaintenance && !isClientRevision) return true
                 return false
             }
             const subDevice = () => {
                onClickPin()
                //console.log("alkwjenflkweNF", subRevision(), templateDeadlines)
            }

            const isSubstitutionNonConformity = item?.substitution ? true : false
            const isArchived = device?.status == "ARCHIVIATO"
            const subString = substitutionString({device: device, registerTemplate: currentTemplate, nonConformity: item || substitutionItem, client, excludeLabel: true})
            return(
                <div key={item?._id ? item?._id : index}  style={{display:"flex", alignItems:"center", marginLeft: "10px"}}> 

                    <VisDiv rules = {[!isArchived, !substitutionItem, !isSubstitutionNonConformity && !subRevision()]} style={{marginRight:"10px"}} onClick={changeDate}>
                        <div style={{backgroundColor:"red", minWidth:"28px", color:"white", display:"flex", alignItems:"center", justifyContent:"center", marginRight:"10px", width:"30px", height:"30px"}}>
                            <MdDateRange size={18} />
                        </div>
                    </VisDiv>  
                    <VisDiv style={{marginRight:"1px"}} rules={[!isArchived, isSubstitutionNonConformity || subRevision() || substitutionItem]} onClick={subDevice}>
                        <div style={{backgroundColor:"red", color:"white", display:"flex", alignItems:"center", justifyContent:"center", marginRight:"10px", width:"30px", height:"30px"}}>
                            <FaExchangeAlt  size={18} />
                        </div>
                    </VisDiv>  
                    <VisDiv rules={[isArchived]}>
                        <div style={{backgroundColor:"green", minWidth:"28px", color:"white", display:"flex", alignItems:"center", justifyContent:"center", marginRight:"10px", width:"30px", height:"30px"}}>
                            <IoMdCheckmark size={15}/>
                        </div>
                    </VisDiv>
                    <div style={{display:'flex', textAlign:'left', flex:9}}>
                        {subString ? subString : item?.label }
                    </div>

                </div>
            )
        })}
    </VisDiv>
        )
    }
